import request from '@/utils/request'

// 获取分组后的朋友圈动态（支持分页）
export function getGroupedMoments (params = {}) {
  return request({
    url: '/post/getTimelinePosts',
    method: 'get',
    params
  })
}

// 发布朋友圈
export function publishMoment ({ content, images = [], videos = [] }) {
  return request({
    url: '/post/publish',
    method: 'post',
    data: { content, images, videos }
  })
}

// 点赞朋友圈
export function likeOrchardMoment (id) {
  return request.post('/post/like', { id })
}

// 取消点赞
export function unlikeOrchardMoment (id) {
  return request.post('/post/unlike', { id })
}

// 评论朋友圈
export function commentMoment (momentId, content) {
  return request({
    url: `/post/${momentId}/comment`,
    method: 'post',
    data: { content }
  })
}
